module.exports = __webpack_public_path__ + "img/doit-watermark.ac1e5f97.jpg";